import { render, staticRenderFns } from "./tax-rate.vue?vue&type=template&id=4ea49654&scoped=true&"
import script from "./tax-rate.vue?vue&type=script&lang=js&"
export * from "./tax-rate.vue?vue&type=script&lang=js&"
import style0 from "./tax-rate.vue?vue&type=style&index=0&id=4ea49654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea49654",
  null
  
)

export default component.exports